const Anh = () => {
  return (
    <div className='flex items-center justify-center pb-5'>
      <div className='tracking-normal text-base sm:text-3xl md:text-3xl lg:text-4xl xl:text-5xl 2xl:text-6xl'>
        <h1 className='text-slate-50 pt-5 pb-2 flex items-center justify-center font-bold text-5xl sm:text-6xl sm:pb-5 md:text-8xl lg:text-9xl xl:text-9xl 2xl:text-9xl'>Anh Em Ta Về</h1>
        <div className='sm:pl-8'>
          <p className='text-slate-300 pt-5 leading-tight'>
            Anh em ta về cùng nhau ta quây quần (nè)<br />
            1, 2, 3, 4, 5
          </p>
          <p className='text-slate-300 pt-5 leading-tight'>
            Anh em ta về cùng nhau ta xum họp (nè)<br />
            5, 4, 3, 2, 1
          </p>
          <ol className='text-slate-300 list-decimal pl-5 pt-5'>
            <li>đều chân bước nhé!</li>
            <li>quay nhìn nhau đi!</li>
            <li>cầm tay chắc nhé <br /> Không muốn ai chia lìa!</li>
            <li>nhớ rằng: chúng ta bốn bể anh em một nhà!</li>
            <li>nhớ mãi tình này trong câu ca</li>
          </ol>
        </div>

      </div>
    </div>
  )
}

export default Anh
